/* generated by Svelte v3.44.2 */
import { SvelteComponent, binding_callbacks, create_slot, detach, element, get_all_dirty_from_scope, get_slot_changes, init, insert, listen, run_all, safe_not_equal, set_custom_element_data, transition_in, transition_out, update_slot_base } from "svelte/internal";
import { define } from '../lib';
import { VmPlayer } from '@vime/core';
import { createEventDispatcher, onMount } from 'svelte';
import { setProp } from '../lib';
function create_fragment(ctx) {
    let vm_player;
    let current;
    let mounted;
    let dispose;
    const default_slot_template = /*#slots*/ ctx[86].default;
    const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[85], null);
    return {
        c() {
            vm_player = element("vm-player");
            if (default_slot)
                default_slot.c();
            set_custom_element_data(vm_player, "class", /*className*/ ctx[0]);
            set_custom_element_data(vm_player, "style", /*style*/ ctx[1]);
            set_custom_element_data(vm_player, "theme", /*theme*/ ctx[2]);
            set_custom_element_data(vm_player, "icons", /*icons*/ ctx[3]);
            set_custom_element_data(vm_player, "paused", /*paused*/ ctx[4]);
            set_custom_element_data(vm_player, "playing", /*playing*/ ctx[5]);
            set_custom_element_data(vm_player, "duration", /*duration*/ ctx[6]);
            set_custom_element_data(vm_player, "media-title", /*mediaTitle*/ ctx[7]);
            set_custom_element_data(vm_player, "current-provider", /*currentProvider*/ ctx[8]);
            set_custom_element_data(vm_player, "current-src", /*currentSrc*/ ctx[9]);
            set_custom_element_data(vm_player, "current-poster", /*currentPoster*/ ctx[10]);
            set_custom_element_data(vm_player, "current-time", /*currentTime*/ ctx[11]);
            set_custom_element_data(vm_player, "autoplay", /*autoplay*/ ctx[12]);
            set_custom_element_data(vm_player, "ready", /*ready*/ ctx[13]);
            set_custom_element_data(vm_player, "playback-ready", /*playbackReady*/ ctx[14]);
            set_custom_element_data(vm_player, "loop", /*loop*/ ctx[15]);
            set_custom_element_data(vm_player, "muted", /*muted*/ ctx[16]);
            set_custom_element_data(vm_player, "buffered", /*buffered*/ ctx[17]);
            set_custom_element_data(vm_player, "playback-rate", /*playbackRate*/ ctx[18]);
            set_custom_element_data(vm_player, "playback-quality", /*playbackQuality*/ ctx[19]);
            set_custom_element_data(vm_player, "seeking", /*seeking*/ ctx[20]);
            set_custom_element_data(vm_player, "debug", /*debug*/ ctx[21]);
            set_custom_element_data(vm_player, "playback-started", /*playbackStarted*/ ctx[22]);
            set_custom_element_data(vm_player, "playback-ended", /*playbackEnded*/ ctx[23]);
            set_custom_element_data(vm_player, "buffering", /*buffering*/ ctx[24]);
            set_custom_element_data(vm_player, "controls", /*controls*/ ctx[25]);
            set_custom_element_data(vm_player, "is-controls-active", /*isControlsActive*/ ctx[26]);
            set_custom_element_data(vm_player, "is-settings-active", /*isSettingsActive*/ ctx[27]);
            set_custom_element_data(vm_player, "volume", /*volume*/ ctx[28]);
            set_custom_element_data(vm_player, "is-fullscreen-active", /*isFullscreenActive*/ ctx[29]);
            set_custom_element_data(vm_player, "aspect-ratio", /*aspectRatio*/ ctx[30]);
            set_custom_element_data(vm_player, "view-type", /*viewType*/ ctx[31]);
            set_custom_element_data(vm_player, "is-audio-view", /*isAudioView*/ ctx[32]);
            set_custom_element_data(vm_player, "is-video-view", /*isVideoView*/ ctx[33]);
            set_custom_element_data(vm_player, "media-type", /*mediaType*/ ctx[34]);
            set_custom_element_data(vm_player, "is-audio", /*isAudio*/ ctx[35]);
            set_custom_element_data(vm_player, "is-video", /*isVideo*/ ctx[36]);
            set_custom_element_data(vm_player, "is-live", /*isLive*/ ctx[37]);
            set_custom_element_data(vm_player, "is-mobile", /*isMobile*/ ctx[38]);
            set_custom_element_data(vm_player, "is-touch", /*isTouch*/ ctx[39]);
            set_custom_element_data(vm_player, "is-pi-p-active", /*isPiPActive*/ ctx[40]);
            set_custom_element_data(vm_player, "current-text-track", /*currentTextTrack*/ ctx[41]);
            set_custom_element_data(vm_player, "is-text-track-visible", /*isTextTrackVisible*/ ctx[42]);
            set_custom_element_data(vm_player, "should-render-native-text-tracks", /*shouldRenderNativeTextTracks*/ ctx[43]);
            set_custom_element_data(vm_player, "current-audio-track", /*currentAudioTrack*/ ctx[44]);
            set_custom_element_data(vm_player, "autopause", /*autopause*/ ctx[45]);
            set_custom_element_data(vm_player, "playsinline", /*playsinline*/ ctx[46]);
            set_custom_element_data(vm_player, "language", /*language*/ ctx[47]);
        },
        m(target, anchor) {
            insert(target, vm_player, anchor);
            if (default_slot) {
                default_slot.m(vm_player, null);
            }
            /*vm_player_binding*/ ctx[87](vm_player);
            current = true;
            if (!mounted) {
                dispose = [
                    listen(vm_player, "vmThemeChange", /*onEvent*/ ctx[49]),
                    listen(vm_player, "vmPausedChange", /*onEvent*/ ctx[49]),
                    listen(vm_player, "vmPlay", /*onEvent*/ ctx[49]),
                    listen(vm_player, "vmPlayingChange", /*onEvent*/ ctx[49]),
                    listen(vm_player, "vmSeekingChange", /*onEvent*/ ctx[49]),
                    listen(vm_player, "vmSeeked", /*onEvent*/ ctx[49]),
                    listen(vm_player, "vmBufferingChange", /*onEvent*/ ctx[49]),
                    listen(vm_player, "vmDurationChange", /*onEvent*/ ctx[49]),
                    listen(vm_player, "vmCurrentTimeChange", /*onEvent*/ ctx[49]),
                    listen(vm_player, "vmReady", /*onEvent*/ ctx[49]),
                    listen(vm_player, "vmPlaybackReady", /*onEvent*/ ctx[49]),
                    listen(vm_player, "vmPlaybackStarted", /*onEvent*/ ctx[49]),
                    listen(vm_player, "vmPlaybackEnded", /*onEvent*/ ctx[49]),
                    listen(vm_player, "vmBufferedChange", /*onEvent*/ ctx[49]),
                    listen(vm_player, "vmError", /*onEvent*/ ctx[49]),
                    listen(vm_player, "vmLoadStart", /*onEvent*/ ctx[49]),
                    listen(vm_player, "vmCurrentProviderChange", /*onEvent*/ ctx[49]),
                    listen(vm_player, "vmCurrentSrcChange", /*onEvent*/ ctx[49]),
                    listen(vm_player, "vmCurrentPosterChange", /*onEvent*/ ctx[49]),
                    listen(vm_player, "vmMediaTitleChange", /*onEvent*/ ctx[49]),
                    listen(vm_player, "vmControlsChange", /*onEvent*/ ctx[49]),
                    listen(vm_player, "vmPlaybackRateChange", /*onEvent*/ ctx[49]),
                    listen(vm_player, "vmPlaybackRatesChange", /*onEvent*/ ctx[49]),
                    listen(vm_player, "vmPlaybackQualityChange", /*onEvent*/ ctx[49]),
                    listen(vm_player, "vmPlaybackQualitiesChange", /*onEvent*/ ctx[49]),
                    listen(vm_player, "vmMutedChange", /*onEvent*/ ctx[49]),
                    listen(vm_player, "vmVolumeChange", /*onEvent*/ ctx[49]),
                    listen(vm_player, "vmViewTypeChange", /*onEvent*/ ctx[49]),
                    listen(vm_player, "vmMediaTypeChange", /*onEvent*/ ctx[49]),
                    listen(vm_player, "vmLiveChange", /*onEvent*/ ctx[49]),
                    listen(vm_player, "vmTouchChange", /*onEvent*/ ctx[49]),
                    listen(vm_player, "vmLanguageChange", /*onEvent*/ ctx[49]),
                    listen(vm_player, "vmI18nChange", /*onEvent*/ ctx[49]),
                    listen(vm_player, "vmTranslationsChange", /*onEvent*/ ctx[49]),
                    listen(vm_player, "vmLanguagesChange", /*onEvent*/ ctx[49]),
                    listen(vm_player, "vmFullscreenChange", /*onEvent*/ ctx[49]),
                    listen(vm_player, "vmPiPChange", /*onEvent*/ ctx[49]),
                    listen(vm_player, "vmTextTracksChange", /*onEvent*/ ctx[49]),
                    listen(vm_player, "vmCurrentTextTrackChange", /*onEvent*/ ctx[49]),
                    listen(vm_player, "vmTextTrackVisibleChange", /*onEvent*/ ctx[49]),
                    listen(vm_player, "vmAudioTracksChange", /*onEvent*/ ctx[49]),
                    listen(vm_player, "vmCurrentAudioTrackChange", /*onEvent*/ ctx[49])
                ];
                mounted = true;
            }
        },
        p(ctx, dirty) {
            if (default_slot) {
                if (default_slot.p && (!current || dirty[2] & /*$$scope*/ 8388608)) {
                    update_slot_base(default_slot, default_slot_template, ctx, 
                    /*$$scope*/ ctx[85], !current
                        ? get_all_dirty_from_scope(/*$$scope*/ ctx[85])
                        : get_slot_changes(default_slot_template, /*$$scope*/ ctx[85], dirty, null), null);
                }
            }
            if (!current || dirty[0] & /*className*/ 1) {
                set_custom_element_data(vm_player, "class", /*className*/ ctx[0]);
            }
            if (!current || dirty[0] & /*style*/ 2) {
                set_custom_element_data(vm_player, "style", /*style*/ ctx[1]);
            }
            if (!current || dirty[0] & /*theme*/ 4) {
                set_custom_element_data(vm_player, "theme", /*theme*/ ctx[2]);
            }
            if (!current || dirty[0] & /*icons*/ 8) {
                set_custom_element_data(vm_player, "icons", /*icons*/ ctx[3]);
            }
            if (!current || dirty[0] & /*paused*/ 16) {
                set_custom_element_data(vm_player, "paused", /*paused*/ ctx[4]);
            }
            if (!current || dirty[0] & /*playing*/ 32) {
                set_custom_element_data(vm_player, "playing", /*playing*/ ctx[5]);
            }
            if (!current || dirty[0] & /*duration*/ 64) {
                set_custom_element_data(vm_player, "duration", /*duration*/ ctx[6]);
            }
            if (!current || dirty[0] & /*mediaTitle*/ 128) {
                set_custom_element_data(vm_player, "media-title", /*mediaTitle*/ ctx[7]);
            }
            if (!current || dirty[0] & /*currentProvider*/ 256) {
                set_custom_element_data(vm_player, "current-provider", /*currentProvider*/ ctx[8]);
            }
            if (!current || dirty[0] & /*currentSrc*/ 512) {
                set_custom_element_data(vm_player, "current-src", /*currentSrc*/ ctx[9]);
            }
            if (!current || dirty[0] & /*currentPoster*/ 1024) {
                set_custom_element_data(vm_player, "current-poster", /*currentPoster*/ ctx[10]);
            }
            if (!current || dirty[0] & /*currentTime*/ 2048) {
                set_custom_element_data(vm_player, "current-time", /*currentTime*/ ctx[11]);
            }
            if (!current || dirty[0] & /*autoplay*/ 4096) {
                set_custom_element_data(vm_player, "autoplay", /*autoplay*/ ctx[12]);
            }
            if (!current || dirty[0] & /*ready*/ 8192) {
                set_custom_element_data(vm_player, "ready", /*ready*/ ctx[13]);
            }
            if (!current || dirty[0] & /*playbackReady*/ 16384) {
                set_custom_element_data(vm_player, "playback-ready", /*playbackReady*/ ctx[14]);
            }
            if (!current || dirty[0] & /*loop*/ 32768) {
                set_custom_element_data(vm_player, "loop", /*loop*/ ctx[15]);
            }
            if (!current || dirty[0] & /*muted*/ 65536) {
                set_custom_element_data(vm_player, "muted", /*muted*/ ctx[16]);
            }
            if (!current || dirty[0] & /*buffered*/ 131072) {
                set_custom_element_data(vm_player, "buffered", /*buffered*/ ctx[17]);
            }
            if (!current || dirty[0] & /*playbackRate*/ 262144) {
                set_custom_element_data(vm_player, "playback-rate", /*playbackRate*/ ctx[18]);
            }
            if (!current || dirty[0] & /*playbackQuality*/ 524288) {
                set_custom_element_data(vm_player, "playback-quality", /*playbackQuality*/ ctx[19]);
            }
            if (!current || dirty[0] & /*seeking*/ 1048576) {
                set_custom_element_data(vm_player, "seeking", /*seeking*/ ctx[20]);
            }
            if (!current || dirty[0] & /*debug*/ 2097152) {
                set_custom_element_data(vm_player, "debug", /*debug*/ ctx[21]);
            }
            if (!current || dirty[0] & /*playbackStarted*/ 4194304) {
                set_custom_element_data(vm_player, "playback-started", /*playbackStarted*/ ctx[22]);
            }
            if (!current || dirty[0] & /*playbackEnded*/ 8388608) {
                set_custom_element_data(vm_player, "playback-ended", /*playbackEnded*/ ctx[23]);
            }
            if (!current || dirty[0] & /*buffering*/ 16777216) {
                set_custom_element_data(vm_player, "buffering", /*buffering*/ ctx[24]);
            }
            if (!current || dirty[0] & /*controls*/ 33554432) {
                set_custom_element_data(vm_player, "controls", /*controls*/ ctx[25]);
            }
            if (!current || dirty[0] & /*isControlsActive*/ 67108864) {
                set_custom_element_data(vm_player, "is-controls-active", /*isControlsActive*/ ctx[26]);
            }
            if (!current || dirty[0] & /*isSettingsActive*/ 134217728) {
                set_custom_element_data(vm_player, "is-settings-active", /*isSettingsActive*/ ctx[27]);
            }
            if (!current || dirty[0] & /*volume*/ 268435456) {
                set_custom_element_data(vm_player, "volume", /*volume*/ ctx[28]);
            }
            if (!current || dirty[0] & /*isFullscreenActive*/ 536870912) {
                set_custom_element_data(vm_player, "is-fullscreen-active", /*isFullscreenActive*/ ctx[29]);
            }
            if (!current || dirty[0] & /*aspectRatio*/ 1073741824) {
                set_custom_element_data(vm_player, "aspect-ratio", /*aspectRatio*/ ctx[30]);
            }
            if (!current || dirty[1] & /*viewType*/ 1) {
                set_custom_element_data(vm_player, "view-type", /*viewType*/ ctx[31]);
            }
            if (!current || dirty[1] & /*isAudioView*/ 2) {
                set_custom_element_data(vm_player, "is-audio-view", /*isAudioView*/ ctx[32]);
            }
            if (!current || dirty[1] & /*isVideoView*/ 4) {
                set_custom_element_data(vm_player, "is-video-view", /*isVideoView*/ ctx[33]);
            }
            if (!current || dirty[1] & /*mediaType*/ 8) {
                set_custom_element_data(vm_player, "media-type", /*mediaType*/ ctx[34]);
            }
            if (!current || dirty[1] & /*isAudio*/ 16) {
                set_custom_element_data(vm_player, "is-audio", /*isAudio*/ ctx[35]);
            }
            if (!current || dirty[1] & /*isVideo*/ 32) {
                set_custom_element_data(vm_player, "is-video", /*isVideo*/ ctx[36]);
            }
            if (!current || dirty[1] & /*isLive*/ 64) {
                set_custom_element_data(vm_player, "is-live", /*isLive*/ ctx[37]);
            }
            if (!current || dirty[1] & /*isMobile*/ 128) {
                set_custom_element_data(vm_player, "is-mobile", /*isMobile*/ ctx[38]);
            }
            if (!current || dirty[1] & /*isTouch*/ 256) {
                set_custom_element_data(vm_player, "is-touch", /*isTouch*/ ctx[39]);
            }
            if (!current || dirty[1] & /*isPiPActive*/ 512) {
                set_custom_element_data(vm_player, "is-pi-p-active", /*isPiPActive*/ ctx[40]);
            }
            if (!current || dirty[1] & /*currentTextTrack*/ 1024) {
                set_custom_element_data(vm_player, "current-text-track", /*currentTextTrack*/ ctx[41]);
            }
            if (!current || dirty[1] & /*isTextTrackVisible*/ 2048) {
                set_custom_element_data(vm_player, "is-text-track-visible", /*isTextTrackVisible*/ ctx[42]);
            }
            if (!current || dirty[1] & /*shouldRenderNativeTextTracks*/ 4096) {
                set_custom_element_data(vm_player, "should-render-native-text-tracks", /*shouldRenderNativeTextTracks*/ ctx[43]);
            }
            if (!current || dirty[1] & /*currentAudioTrack*/ 8192) {
                set_custom_element_data(vm_player, "current-audio-track", /*currentAudioTrack*/ ctx[44]);
            }
            if (!current || dirty[1] & /*autopause*/ 16384) {
                set_custom_element_data(vm_player, "autopause", /*autopause*/ ctx[45]);
            }
            if (!current || dirty[1] & /*playsinline*/ 32768) {
                set_custom_element_data(vm_player, "playsinline", /*playsinline*/ ctx[46]);
            }
            if (!current || dirty[1] & /*language*/ 65536) {
                set_custom_element_data(vm_player, "language", /*language*/ ctx[47]);
            }
        },
        i(local) {
            if (current)
                return;
            transition_in(default_slot, local);
            current = true;
        },
        o(local) {
            transition_out(default_slot, local);
            current = false;
        },
        d(detaching) {
            if (detaching)
                detach(vm_player);
            if (default_slot)
                default_slot.d(detaching);
            /*vm_player_binding*/ ctx[87](null);
            mounted = false;
            run_all(dispose);
        }
    };
}
define('vm-player', VmPlayer);
function instance($$self, $$props, $$invalidate) {
    let { $$slots: slots = {}, $$scope } = $$props;
    let __ref;
    let __mounted = false;
    const dispatch = createEventDispatcher();
    let { class: className = '' } = $$props;
    let { style = '' } = $$props;
    let { logger = undefined } = $$props;
    let { theme = undefined } = $$props;
    let { icons = 'vime' } = $$props;
    let { paused = true } = $$props;
    let { playing = false } = $$props;
    let { duration = -1 } = $$props;
    let { mediaTitle = undefined } = $$props;
    let { currentProvider = undefined } = $$props;
    let { currentSrc = undefined } = $$props;
    let { currentPoster = undefined } = $$props;
    let { currentTime = 0 } = $$props;
    let { autoplay = false } = $$props;
    let { ready = false } = $$props;
    let { playbackReady = false } = $$props;
    let { loop = false } = $$props;
    let { muted = false } = $$props;
    let { buffered = 0 } = $$props;
    let { playbackRate = 1 } = $$props;
    let { playbackRates = [1] } = $$props;
    let { playbackQuality = undefined } = $$props;
    let { playbackQualities = [] } = $$props;
    let { seeking = false } = $$props;
    let { debug = false } = $$props;
    let { playbackStarted = false } = $$props;
    let { playbackEnded = false } = $$props;
    let { buffering = false } = $$props;
    let { controls = false } = $$props;
    let { isControlsActive = false } = $$props;
    let { isSettingsActive = false } = $$props;
    let { volume = 50 } = $$props;
    let { isFullscreenActive = false } = $$props;
    let { aspectRatio = '16:9' } = $$props;
    let { viewType = undefined } = $$props;
    let { isAudioView = false } = $$props;
    let { isVideoView = false } = $$props;
    let { mediaType = undefined } = $$props;
    let { isAudio = false } = $$props;
    let { isVideo = false } = $$props;
    let { isLive = false } = $$props;
    let { isMobile = false } = $$props;
    let { isTouch = false } = $$props;
    let { isPiPActive = false } = $$props;
    let { textTracks = [] } = $$props;
    let { currentTextTrack = -1 } = $$props;
    let { isTextTrackVisible = true } = $$props;
    let { shouldRenderNativeTextTracks = true } = $$props;
    let { audioTracks = [] } = $$props;
    let { currentAudioTrack = -1 } = $$props;
    let { autopause = true } = $$props;
    let { playsinline = false } = $$props;
    let { language = 'en' } = $$props;
    let { translations = undefined } = $$props;
    let { languages = ['en'] } = $$props;
    let { i18n = undefined } = $$props;
    const getProvider = (...args) => __ref.getProvider(...args);
    const getAdapter = (...args) => __ref.getAdapter(...args);
    const play = (...args) => __ref.play(...args);
    const pause = (...args) => __ref.pause(...args);
    const canPlay = (...args) => __ref.canPlay(...args);
    const canAutoplay = (...args) => __ref.canAutoplay(...args);
    const canMutedAutoplay = (...args) => __ref.canMutedAutoplay(...args);
    const canSetPlaybackRate = (...args) => __ref.canSetPlaybackRate(...args);
    const canSetPlaybackQuality = (...args) => __ref.canSetPlaybackQuality(...args);
    const canSetFullscreen = (...args) => __ref.canSetFullscreen(...args);
    const enterFullscreen = (...args) => __ref.enterFullscreen(...args);
    const exitFullscreen = (...args) => __ref.exitFullscreen(...args);
    const canSetPiP = (...args) => __ref.canSetPiP(...args);
    const enterPiP = (...args) => __ref.enterPiP(...args);
    const exitPiP = (...args) => __ref.exitPiP(...args);
    const canSetAudioTrack = (...args) => __ref.canSetAudioTrack(...args);
    const setCurrentAudioTrack = (...args) => __ref.setCurrentAudioTrack(...args);
    const canSetTextTrack = (...args) => __ref.canSetTextTrack(...args);
    const setCurrentTextTrack = (...args) => __ref.setCurrentTextTrack(...args);
    const canSetTextTrackVisibility = (...args) => __ref.canSetTextTrackVisibility(...args);
    const setTextTrackVisibility = (...args) => __ref.setTextTrackVisibility(...args);
    const extendLanguage = (...args) => __ref.extendLanguage(...args);
    const getContainer = (...args) => __ref.getContainer(...args);
    const callAdapter = (...args) => __ref.callAdapter(...args);
    const ref = () => __ref;
    const getWebComponent = () => __ref;
    onMount(() => {
        $$invalidate(50, logger = logger === void 0 ? __ref['logger'] : logger);
        $$invalidate(51, translations = translations === void 0
            ? __ref['translations']
            : translations);
        $$invalidate(52, i18n = i18n === void 0 ? __ref['i18n'] : i18n);
        $$invalidate(84, __mounted = true);
    });
    const onEvent = e => {
        e.stopPropagation();
        dispatch(e.type, e.detail);
    };
    function vm_player_binding($$value) {
        binding_callbacks[$$value ? 'unshift' : 'push'](() => {
            __ref = $$value;
            $$invalidate(48, __ref);
        });
    }
    $$self.$$set = $$props => {
        if ('class' in $$props)
            $$invalidate(0, className = $$props.class);
        if ('style' in $$props)
            $$invalidate(1, style = $$props.style);
        if ('logger' in $$props)
            $$invalidate(50, logger = $$props.logger);
        if ('theme' in $$props)
            $$invalidate(2, theme = $$props.theme);
        if ('icons' in $$props)
            $$invalidate(3, icons = $$props.icons);
        if ('paused' in $$props)
            $$invalidate(4, paused = $$props.paused);
        if ('playing' in $$props)
            $$invalidate(5, playing = $$props.playing);
        if ('duration' in $$props)
            $$invalidate(6, duration = $$props.duration);
        if ('mediaTitle' in $$props)
            $$invalidate(7, mediaTitle = $$props.mediaTitle);
        if ('currentProvider' in $$props)
            $$invalidate(8, currentProvider = $$props.currentProvider);
        if ('currentSrc' in $$props)
            $$invalidate(9, currentSrc = $$props.currentSrc);
        if ('currentPoster' in $$props)
            $$invalidate(10, currentPoster = $$props.currentPoster);
        if ('currentTime' in $$props)
            $$invalidate(11, currentTime = $$props.currentTime);
        if ('autoplay' in $$props)
            $$invalidate(12, autoplay = $$props.autoplay);
        if ('ready' in $$props)
            $$invalidate(13, ready = $$props.ready);
        if ('playbackReady' in $$props)
            $$invalidate(14, playbackReady = $$props.playbackReady);
        if ('loop' in $$props)
            $$invalidate(15, loop = $$props.loop);
        if ('muted' in $$props)
            $$invalidate(16, muted = $$props.muted);
        if ('buffered' in $$props)
            $$invalidate(17, buffered = $$props.buffered);
        if ('playbackRate' in $$props)
            $$invalidate(18, playbackRate = $$props.playbackRate);
        if ('playbackRates' in $$props)
            $$invalidate(53, playbackRates = $$props.playbackRates);
        if ('playbackQuality' in $$props)
            $$invalidate(19, playbackQuality = $$props.playbackQuality);
        if ('playbackQualities' in $$props)
            $$invalidate(54, playbackQualities = $$props.playbackQualities);
        if ('seeking' in $$props)
            $$invalidate(20, seeking = $$props.seeking);
        if ('debug' in $$props)
            $$invalidate(21, debug = $$props.debug);
        if ('playbackStarted' in $$props)
            $$invalidate(22, playbackStarted = $$props.playbackStarted);
        if ('playbackEnded' in $$props)
            $$invalidate(23, playbackEnded = $$props.playbackEnded);
        if ('buffering' in $$props)
            $$invalidate(24, buffering = $$props.buffering);
        if ('controls' in $$props)
            $$invalidate(25, controls = $$props.controls);
        if ('isControlsActive' in $$props)
            $$invalidate(26, isControlsActive = $$props.isControlsActive);
        if ('isSettingsActive' in $$props)
            $$invalidate(27, isSettingsActive = $$props.isSettingsActive);
        if ('volume' in $$props)
            $$invalidate(28, volume = $$props.volume);
        if ('isFullscreenActive' in $$props)
            $$invalidate(29, isFullscreenActive = $$props.isFullscreenActive);
        if ('aspectRatio' in $$props)
            $$invalidate(30, aspectRatio = $$props.aspectRatio);
        if ('viewType' in $$props)
            $$invalidate(31, viewType = $$props.viewType);
        if ('isAudioView' in $$props)
            $$invalidate(32, isAudioView = $$props.isAudioView);
        if ('isVideoView' in $$props)
            $$invalidate(33, isVideoView = $$props.isVideoView);
        if ('mediaType' in $$props)
            $$invalidate(34, mediaType = $$props.mediaType);
        if ('isAudio' in $$props)
            $$invalidate(35, isAudio = $$props.isAudio);
        if ('isVideo' in $$props)
            $$invalidate(36, isVideo = $$props.isVideo);
        if ('isLive' in $$props)
            $$invalidate(37, isLive = $$props.isLive);
        if ('isMobile' in $$props)
            $$invalidate(38, isMobile = $$props.isMobile);
        if ('isTouch' in $$props)
            $$invalidate(39, isTouch = $$props.isTouch);
        if ('isPiPActive' in $$props)
            $$invalidate(40, isPiPActive = $$props.isPiPActive);
        if ('textTracks' in $$props)
            $$invalidate(55, textTracks = $$props.textTracks);
        if ('currentTextTrack' in $$props)
            $$invalidate(41, currentTextTrack = $$props.currentTextTrack);
        if ('isTextTrackVisible' in $$props)
            $$invalidate(42, isTextTrackVisible = $$props.isTextTrackVisible);
        if ('shouldRenderNativeTextTracks' in $$props)
            $$invalidate(43, shouldRenderNativeTextTracks = $$props.shouldRenderNativeTextTracks);
        if ('audioTracks' in $$props)
            $$invalidate(56, audioTracks = $$props.audioTracks);
        if ('currentAudioTrack' in $$props)
            $$invalidate(44, currentAudioTrack = $$props.currentAudioTrack);
        if ('autopause' in $$props)
            $$invalidate(45, autopause = $$props.autopause);
        if ('playsinline' in $$props)
            $$invalidate(46, playsinline = $$props.playsinline);
        if ('language' in $$props)
            $$invalidate(47, language = $$props.language);
        if ('translations' in $$props)
            $$invalidate(51, translations = $$props.translations);
        if ('languages' in $$props)
            $$invalidate(57, languages = $$props.languages);
        if ('i18n' in $$props)
            $$invalidate(52, i18n = $$props.i18n);
        if ('$$scope' in $$props)
            $$invalidate(85, $$scope = $$props.$$scope);
    };
    $$self.$$.update = () => {
        if ($$self.$$.dirty[1] & /*__ref, logger*/ 655360 | $$self.$$.dirty[2] & /*__mounted*/ 4194304) {
            $: if (__mounted)
                setProp(__ref, 'logger', logger);
        }
        if ($$self.$$.dirty[1] & /*__ref, playbackRates*/ 4325376 | $$self.$$.dirty[2] & /*__mounted*/ 4194304) {
            $: if (__mounted)
                setProp(__ref, 'playbackRates', playbackRates);
        }
        if ($$self.$$.dirty[1] & /*__ref, playbackQualities*/ 8519680 | $$self.$$.dirty[2] & /*__mounted*/ 4194304) {
            $: if (__mounted)
                setProp(__ref, 'playbackQualities', playbackQualities);
        }
        if ($$self.$$.dirty[1] & /*__ref, textTracks*/ 16908288 | $$self.$$.dirty[2] & /*__mounted*/ 4194304) {
            $: if (__mounted)
                setProp(__ref, 'textTracks', textTracks);
        }
        if ($$self.$$.dirty[1] & /*__ref, audioTracks*/ 33685504 | $$self.$$.dirty[2] & /*__mounted*/ 4194304) {
            $: if (__mounted)
                setProp(__ref, 'audioTracks', audioTracks);
        }
        if ($$self.$$.dirty[1] & /*__ref, translations*/ 1179648 | $$self.$$.dirty[2] & /*__mounted*/ 4194304) {
            $: if (__mounted)
                setProp(__ref, 'translations', translations);
        }
        if ($$self.$$.dirty[1] & /*__ref, languages*/ 67239936 | $$self.$$.dirty[2] & /*__mounted*/ 4194304) {
            $: if (__mounted)
                setProp(__ref, 'languages', languages);
        }
        if ($$self.$$.dirty[1] & /*__ref, i18n*/ 2228224 | $$self.$$.dirty[2] & /*__mounted*/ 4194304) {
            $: if (__mounted)
                setProp(__ref, 'i18n', i18n);
        }
    };
    return [
        className,
        style,
        theme,
        icons,
        paused,
        playing,
        duration,
        mediaTitle,
        currentProvider,
        currentSrc,
        currentPoster,
        currentTime,
        autoplay,
        ready,
        playbackReady,
        loop,
        muted,
        buffered,
        playbackRate,
        playbackQuality,
        seeking,
        debug,
        playbackStarted,
        playbackEnded,
        buffering,
        controls,
        isControlsActive,
        isSettingsActive,
        volume,
        isFullscreenActive,
        aspectRatio,
        viewType,
        isAudioView,
        isVideoView,
        mediaType,
        isAudio,
        isVideo,
        isLive,
        isMobile,
        isTouch,
        isPiPActive,
        currentTextTrack,
        isTextTrackVisible,
        shouldRenderNativeTextTracks,
        currentAudioTrack,
        autopause,
        playsinline,
        language,
        __ref,
        onEvent,
        logger,
        translations,
        i18n,
        playbackRates,
        playbackQualities,
        textTracks,
        audioTracks,
        languages,
        getProvider,
        getAdapter,
        play,
        pause,
        canPlay,
        canAutoplay,
        canMutedAutoplay,
        canSetPlaybackRate,
        canSetPlaybackQuality,
        canSetFullscreen,
        enterFullscreen,
        exitFullscreen,
        canSetPiP,
        enterPiP,
        exitPiP,
        canSetAudioTrack,
        setCurrentAudioTrack,
        canSetTextTrack,
        setCurrentTextTrack,
        canSetTextTrackVisibility,
        setTextTrackVisibility,
        extendLanguage,
        getContainer,
        callAdapter,
        ref,
        getWebComponent,
        __mounted,
        $$scope,
        slots,
        vm_player_binding
    ];
}
class Player extends SvelteComponent {
    constructor(options) {
        super();
        init(this, options, instance, create_fragment, safe_not_equal, {
            class: 0,
            style: 1,
            logger: 50,
            theme: 2,
            icons: 3,
            paused: 4,
            playing: 5,
            duration: 6,
            mediaTitle: 7,
            currentProvider: 8,
            currentSrc: 9,
            currentPoster: 10,
            currentTime: 11,
            autoplay: 12,
            ready: 13,
            playbackReady: 14,
            loop: 15,
            muted: 16,
            buffered: 17,
            playbackRate: 18,
            playbackRates: 53,
            playbackQuality: 19,
            playbackQualities: 54,
            seeking: 20,
            debug: 21,
            playbackStarted: 22,
            playbackEnded: 23,
            buffering: 24,
            controls: 25,
            isControlsActive: 26,
            isSettingsActive: 27,
            volume: 28,
            isFullscreenActive: 29,
            aspectRatio: 30,
            viewType: 31,
            isAudioView: 32,
            isVideoView: 33,
            mediaType: 34,
            isAudio: 35,
            isVideo: 36,
            isLive: 37,
            isMobile: 38,
            isTouch: 39,
            isPiPActive: 40,
            textTracks: 55,
            currentTextTrack: 41,
            isTextTrackVisible: 42,
            shouldRenderNativeTextTracks: 43,
            audioTracks: 56,
            currentAudioTrack: 44,
            autopause: 45,
            playsinline: 46,
            language: 47,
            translations: 51,
            languages: 57,
            i18n: 52,
            getProvider: 58,
            getAdapter: 59,
            play: 60,
            pause: 61,
            canPlay: 62,
            canAutoplay: 63,
            canMutedAutoplay: 64,
            canSetPlaybackRate: 65,
            canSetPlaybackQuality: 66,
            canSetFullscreen: 67,
            enterFullscreen: 68,
            exitFullscreen: 69,
            canSetPiP: 70,
            enterPiP: 71,
            exitPiP: 72,
            canSetAudioTrack: 73,
            setCurrentAudioTrack: 74,
            canSetTextTrack: 75,
            setCurrentTextTrack: 76,
            canSetTextTrackVisibility: 77,
            setTextTrackVisibility: 78,
            extendLanguage: 79,
            getContainer: 80,
            callAdapter: 81,
            ref: 82,
            getWebComponent: 83
        }, null, [-1, -1, -1]);
    }
    $on(type, callback) {
        return super.$on(type, callback);
    }
    $set($$props) {
        super.$set($$props);
    }
    /** Returns the current media provider. */
    get getProvider() {
        return this.$$.ctx[58];
    }
    /** Returns the current media provider's adapter. Shorthand for `getProvider().getAdapter()`. */
    get getAdapter() {
        return this.$$.ctx[59];
    }
    /** Begins/resumes playback of the media. If this method is called programmatically before the user
  has interacted with the player, the promise may be rejected subject to the browser's autoplay
  policies. */
    get play() {
        return this.$$.ctx[60];
    }
    /** Pauses playback of the media. */
    get pause() {
        return this.$$.ctx[61];
    }
    /** Determines whether the current provider recognizes, and can play the given type. */
    get canPlay() {
        return this.$$.ctx[62];
    }
    /** Determines whether the player can start playback of the current media automatically. */
    get canAutoplay() {
        return this.$$.ctx[63];
    }
    /** Determines whether the player can start playback of the current media automatically given the
  player is muted. */
    get canMutedAutoplay() {
        return this.$$.ctx[64];
    }
    /** Returns whether the current provider allows setting the `playbackRate` prop. */
    get canSetPlaybackRate() {
        return this.$$.ctx[65];
    }
    /** Returns whether the current provider allows setting the `playbackQuality` prop. */
    get canSetPlaybackQuality() {
        return this.$$.ctx[66];
    }
    /** Returns whether the native browser fullscreen API is available, or the current provider can
  toggle fullscreen mode. This does not mean that the operation is guaranteed to be successful,
  only that it can be attempted. */
    get canSetFullscreen() {
        return this.$$.ctx[67];
    }
    /** Requests to enter fullscreen mode, returning a `Promise` that will resolve if the request is
  made, or reject with a reason for failure. This method will first attempt to use the browsers
  native fullscreen API, and then fallback to requesting the provider to do it (if available).
  Do not rely on a resolved promise to determine if the player is in fullscreen or not. The only
  way to be certain is by listening to the `vmFullscreenChange` event. Some common reasons for
  failure are: the fullscreen API is not available, the request is made when `viewType` is audio,
  or the user has not interacted with the page yet. */
    get enterFullscreen() {
        return this.$$.ctx[68];
    }
    /** Requests to exit fullscreen mode, returning a `Promise` that will resolve if the request is
  successful, or reject with a reason for failure. Refer to `enterFullscreen()` for more
  information. */
    get exitFullscreen() {
        return this.$$.ctx[69];
    }
    /** Returns whether the current provider exposes an API for entering and exiting
  picture-in-picture mode. This does not mean the operation is guaranteed to be successful, only
  that it can be attempted. */
    get canSetPiP() {
        return this.$$.ctx[70];
    }
    /** Request to enter picture-in-picture (PiP) mode, returning a `Promise` that will resolve if
  the request is made, or reject with a reason for failure. Do not rely on a resolved promise
  to determine if the player is in PiP mode or not. The only way to be certain is by listening
  to the `vmPiPChange` event. Some common reasons for failure are the same as the reasons for
  `enterFullscreen()`. */
    get enterPiP() {
        return this.$$.ctx[71];
    }
    /** Request to exit picture-in-picture mode, returns a `Promise` that will resolve if the request
  is successful, or reject with a reason for failure. Refer to `enterPiP()` for more
  information. */
    get exitPiP() {
        return this.$$.ctx[72];
    }
    /** Returns whether the current providers allows changing the audio track. */
    get canSetAudioTrack() {
        return this.$$.ctx[73];
    }
    /** Sets the currently active audio track given the index. */
    get setCurrentAudioTrack() {
        return this.$$.ctx[74];
    }
    /** Returns whether the current provider allows changing the text track. */
    get canSetTextTrack() {
        return this.$$.ctx[75];
    }
    /** Sets the currently active text track given the index. Set to -1 to disable all text tracks. */
    get setCurrentTextTrack() {
        return this.$$.ctx[76];
    }
    /** Returns whether the current providers allows setting the text track visibility. */
    get canSetTextTrackVisibility() {
        return this.$$.ctx[77];
    }
    /** Sets the visibility of the currently active text track. */
    get setTextTrackVisibility() {
        return this.$$.ctx[78];
    }
    /** Extends the translation map for a given language. */
    get extendLanguage() {
        return this.$$.ctx[79];
    }
    /** Returns the inner container. */
    get getContainer() {
        return this.$$.ctx[80];
    }
    /**  */
    get callAdapter() {
        return this.$$.ctx[81];
    }
    get ref() {
        return this.$$.ctx[82];
    }
    get getWebComponent() {
        return this.$$.ctx[83];
    }
}
export default Player;
//# sourceMappingURL=Player.js.map